import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

export const ItemContainer = styled(RouterLink)`
    display: grid;
    cursor: pointer;
    grid-template-columns: 100px auto 1fr;
    gap: 8px;
`;

export const MealTag = styled.div`
    border-radius: ${({ theme }) => `${theme['border-radius-small']}px`};
    width: fit-content;
    padding: 4px 8px;
    background-color: rgba(255, 255, 255, 0.06);
    margin-bottom: 4px;
    text-transform: capitalize;
`;

export const Image = styled.div<{ src: string }>`
    width: 100px;
    height: 100px;
    background-image: url(${({ src }) => src});
    background-size: cover;
    background-position: center;
    border-radius: ${({ theme }) => `${theme['border-radius-small']}px`};
`;

export const IconContainer = styled.div`
    margin-left: auto;
    align-self: center;
`;
